// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".imgModaldiv[data-v-4c25385c]{padding-top:10px;padding-bottom:10px}.btn-div[data-v-4c25385c]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}.uploadbtn[data-v-4c25385c]{width:250px}.icon[data-v-4c25385c]{width:40px;height:40px}", ""]);
// Exports
module.exports = exports;
